"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, PropSync, Ref, Vue } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import { TimerEngine } from "@/utils/settimeout";
import vueQr from "vue-qr";
import { DeviceFormatter } from "@/service/DeviceInfo/deviceFormatter";
import AuthPinLogin from "@/app_views/login/components/AuthPinLogin.vue";
import AccountDevice from "@/app_views/login/components/AccountDevice.vue";
import { LoginService } from "@/service/login";
import { WEB_HTML } from "@/configuration/websocketskey";
let loginService = new LoginService();
let WxLogin = class extends Vue {
  constructor() {
    super(...arguments);
    this.qrCode = "";
    this.qrKey = "";
    this.qrLoading = true;
    this.imageUrl = require("../../../assets/logo-64.png");
    this.iconShow = true;
    this.wechat_listener = null;
    this.qr_timer = null;
    this.qr_second = 0;
  }
  mounted() {
    return __async(this, null, function* () {
      yield this.getWxLoginLink();
      yield this.qrTimer();
    });
  }
  beforeDestroy() {
    return __async(this, null, function* () {
      this.stopQrTimer();
      this.stopWechatToken();
    });
  }
  getWxLoginLink() {
    return __async(this, null, function* () {
      try {
        this.qrLoading = true;
        const response = yield API.get("api://base.login/v1/auth-wxlink");
        this.qrCode = response.data.link;
        this.qrKey = response.data.key;
        yield this.getWechatToken();
      } catch (error) {
        console.dir(error);
      } finally {
        this.qrLoading = false;
      }
    });
  }
  //{{$t('wxlogin.interrupt_listener')}}
  stopWechatToken() {
    if (this.wechat_listener !== null) {
      this.wechat_listener.stop();
    }
  }
  //{{$t('wxlogin.listener_polling_get')}}token
  getWechatToken() {
    return __async(this, null, function* () {
      try {
        new Promise((resolve, reject) => {
          let _timeout = setTimeout(() => {
            reject(false);
          }, 3e5);
          this.wechat_listener = new TimerEngine(() => __async(this, null, function* () {
            let response = yield API.get(
              `api://base.login/v1/auth-wx-token/${this.qrKey}`
            );
            console.dir(response);
            if (response.data.status === "success") {
              this.WechatLogin(response.data.token);
              clearInterval(this.qr_timer);
              resolve(true);
            }
          }), 3e3);
          this.wechat_listener.start();
        });
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  //{{$t('wxlogin.listener_polling_get')}}token
  WechatLogin(token) {
    return __async(this, null, function* () {
      var _a, _b, _c, _d;
      try {
        let device = yield DeviceFormatter.getInfo();
        const response = yield API.post(
          "api://base.login/v1/auth-token",
          {
            // const response = await API.post<AccountSessionModel>("api://base/api/v7/account/auth_by_token",{
            model: "token.login",
            deviceInfo: device.device_info,
            deviceCode: device.device_mini,
            deviceName: device.device_name,
            allowLogin: false,
            platform: "pc"
          },
          {
            headers: {
              "x-auth-token": token,
              "Accept-Language": (_a = localStorage.getItem("lang")) != null ? _a : "zh-CN"
            }
          }
        );
        if (response.data.model === "account.pinverify") {
          yield this._auth_pin.open(response.data, "wechat");
          return;
        }
        if (response.data.model === "device.auth") {
          yield this._account_device.open(response.data, "wechat");
          return;
        }
        try {
          const serviceCodeResponse = yield API.get(`api://base.local/storages/session/deviceToken`);
          const serviceToken = serviceCodeResponse.data.value.deviceToken;
          const device_bind_response = yield API.get(`api://base.auth.message/v1/check/user-devices`, {
            params: {
              "deviceId": serviceToken
            },
            headers: {
              "Authorization": response.data.token,
              "Accept-Language": (_b = localStorage.getItem("lang")) != null ? _b : "zh-CN"
            }
          });
          if (device_bind_response.data.bindDevice === true) {
            yield this.$confirm(
              `${this.$t("phonelogin.device_online_tip_content")}<br/>${this.$t("phonelogin.device_online_tip_sub_account")}<a
               href="https://www.kuajingvs.com/help2/7048"
               target="_blank"
               style="text-decoration: none; color: #1DCF6A"
            >${this.$t("phonelogin.device_online_tip_sub_account_link")}</a>`,
              this.$t("vdbindshop.binding_shop_confirm_title"),
              {
                roundButton: true,
                dangerouslyUseHTMLString: true,
                cancelButtonText: `${this.$t("vdbindshop.binding_tip_cancel")}`,
                confirmButtonText: `${this.$t("vdbindshop.binding_tip_confirm")}`,
                closeOnClickModal: false
              }
            );
          }
        } catch (error) {
          if (error === "cancel") {
            return;
          }
        }
        const token_response = yield API.post(
          `api://base.login/v1/auth-temporary-token`,
          {},
          {
            headers: {
              "x-auth-token": response.data.token,
              "Accept-Language": (_c = localStorage.getItem("lang")) != null ? _c : "zh-CN"
            }
          }
        );
        if (token_response.data.marks !== null && token_response.data.marks.tags.includes("TEAM_JOIN_ALERT")) {
          localStorage.setItem("showJoinTeamMessage", "true");
        }
        loginService.setTokenToLocal(token_response.data.token);
        try {
          let version = yield API.get(`api://base.local/update/version`);
          let _version = version.data.version;
          let _session = yield API.get(`api://base.auth.pro/v1/account/session`, {
            headers: {
              "Authorization": token_response.data.token,
              "Accept-Language": (_d = localStorage.getItem("lang")) != null ? _d : "zh-CN"
            }
          });
          const session = _session.data;
          yield loginService.setSessionToLocal(session);
          yield API.post(`api://base.local/websockets/main`, {
            model: "pageEvent.login.success",
            value: {
              message: "login_success",
              session: _session.data
            }
          });
          yield API.post(`api://base.local/websockets/messageservice`, {
            model: "pageEvent.login.success",
            value: {
              message: "login_success",
              session: _session.data
            }
          });
          if (this.$matomo) {
            this.$matomo.setUserId(_session.data.id);
          }
          API.post(`api://base.auth/api/v3/client/logs`, {
            logs: [
              {
                name: "client.login",
                message: "login.success",
                datas: {
                  time: {
                    time: new Date().getTime(),
                    date: new Date()
                  },
                  session: _session.data,
                  version: _version,
                  patch: _version,
                  computer: {
                    graphics: device.device_info.detail.graphics,
                    os_arch: device.device_info.os_arch,
                    cpu: device.device_info.detail.cpu,
                    os: device.device_info.detail.osInfo,
                    memory: device.device_info.detail.mem,
                    network: device.device_info.detail.networkInterfaces,
                    time: {
                      date: new Date()
                    }
                  }
                }
              }
            ]
          });
          let flag = false;
          let _activity_data = null;
          try {
            let response2 = yield API.get(
              `api://base.auth/api/v8/activity-popups`,
              {
                params: {
                  scenes: "login"
                }
              }
            );
            _activity_data = JSON.stringify(response2.data);
            flag = true;
          } catch (error) {
            console.dir(error);
          } finally {
            if (flag) {
              if (this._refer !== "" && this._refer !== null) {
                window.open(`${this._refer}?token=${token_response.data.token}&name=${_session.data.name}`, "_self");
                return;
              }
              let _href = `${WEB_HTML}/?activity=${_activity_data}`;
              if (_session.data.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
                _href = `https://pre.kuajingvs.com/?activity=${_activity_data}`;
              }
              if (this._jump !== "" && this._jump !== null) {
                if (this._jump.indexOf("?") !== -1) {
                  _href = `${WEB_HTML}/${this._jump}&activity=${_activity_data}`;
                  if (_session.data.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
                    _href = `https://pre.kuajingvs.com/${this._jump}&activity=${_activity_data}`;
                  }
                } else {
                  _href = `${WEB_HTML}/${this._jump}?activity=${_activity_data}`;
                  if (_session.data.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
                    _href = `https://pre.kuajingvs.com/${this._jump}?activity=${_activity_data}`;
                  }
                }
                if (this._jump === "rpa") {
                  _href = `https://rpa.kuajingvs.com`;
                }
                if (this._jump === "yunhao") {
                  _href = `https://yunhao.kuajingvs.com/`;
                }
                if (this._jump === "ai") {
                  _href = `https://app.kuajingvs.com/ai`;
                }
              }
              window.open(_href, "_self");
              console.log("kjvs://close");
            }
            if (!flag) {
              if (this._refer !== "" && this._refer !== null) {
                window.open(`${this._refer}?token=${token_response.data.token}&name=${_session.data.name}`, "_self");
              }
              let _href = `${WEB_HTML}/`;
              if (_session.data.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
                _href = `https://pre.kuajingvs.com/`;
              }
              if (this._jump !== "" && this._jump !== null) {
                _href = `${WEB_HTML}/${this._jump}`;
                if (_session.data.marks.is("USE_GRAYSCALE_PRELAUNCH_PAGE")) {
                  _href = `https://pre.kuajingvs.com/${this._jump}`;
                }
                if (this._jump === "rpa") {
                  _href = `https://rpa.kuajingvs.com`;
                }
                if (this._jump === "yunhao") {
                  _href = `https://yunhao.kuajingvs.com/`;
                }
                if (this._jump === "ai") {
                  _href = `https://app.kuajingvs.com/ai`;
                }
              }
              window.open(_href, "_self");
              console.log("kjvs://close");
            }
          }
        } catch (error) {
          console.dir(error);
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  stopQrTimer() {
    return __async(this, null, function* () {
      if (this.qr_timer !== null) {
        this.qr_timer.stop();
      }
    });
  }
  qrTimer() {
    this.qr_second = 300;
    this.qr_timer = new TimerEngine(() => __async(this, null, function* () {
      console.dir(this.qr_second);
      this.qr_second--;
      if (this.qr_second > 0) {
      }
      if (this.qr_second < 0) {
        this.qr_second = 0;
        yield this.stopQrTimer();
        yield this.stopWechatToken();
        yield this.getWxLoginLink();
        yield this.qrTimer();
      }
    }), 1e3);
    this.qr_timer.start();
  }
};
__decorateClass([
  Ref("auth-pin")
], WxLogin.prototype, "_auth_pin", 2);
__decorateClass([
  Ref("account-device")
], WxLogin.prototype, "_account_device", 2);
__decorateClass([
  PropSync("jump")
], WxLogin.prototype, "_jump", 2);
__decorateClass([
  PropSync("refer")
], WxLogin.prototype, "_refer", 2);
WxLogin = __decorateClass([
  Component({
    components: {
      vueQr,
      AuthPinLogin,
      AccountDevice
    }
  })
], WxLogin);
export {
  WxLogin as default
};
